<section class="pass-rules" *ngIf="passwordControl">
  <div>
    <ul class="feedback" *ngIf="passwordControl.touched && passwordControl.hasError('required')">
      <li class="feedback-warning">Do not leave password empty</li>
    </ul>
    <ul class="feedback" *ngIf="passwordControl.touched && passwordControl.hasError('pattern')">
      <li class="feedback-warning">Your password must have:</li>
      <li class="feedback-warning">At least 8 characters</li>
      <li class="feedback-warning">At least 1 uppercase character</li>
      <li class="feedback-warning">At least 1 lowercase character</li>
      <li class="feedback-warning">At least 1 symbol (@$!%*?&amp;)</li>
      <li class="feedback-warning">At least 1 number</li>
    </ul>
  </div>
</section>
